import React from 'react';
import { Button, Typography } from 'seagull';
import styles from "../ChangeEmailAddress.module.scss";
import ContactSupportButton from "../../ContactSupportButton";
const ManyAttemptsError = _ref => {
  let {
    onClose
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "many-attempts-error"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "error-message"
  }, "It looks like you've tried too many times."), /*#__PURE__*/React.createElement(Typography, null, "Try again later or ", /*#__PURE__*/React.createElement(ContactSupportButton, {
    testid: "contact-support-button",
    underline: "none"
  }), ".")), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    skin: "primaryOutline",
    "data-testid": "close-button"
  }, "Close")));
};
export default ManyAttemptsError;